import { render, staticRenderFns } from "./MediaChannal.vue?vue&type=template&id=3ca54367"
import script from "./MediaChannal.vue?vue&type=script&lang=js"
export * from "./MediaChannal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports